<div class="offer-price">
  <app-offer-fixed-price *ngIf="!hasModifications"
                         [showInstalment]="showInstallment"
                         [selectedPremium]="selectedPremium"
                         [offer]="offer">
  </app-offer-fixed-price>
  <app-offer-modification-price *ngIf="hasModifications"
                                [loading]="loading"
                                [price]="currentModificationsPrice">
  </app-offer-modification-price>
</div>
